import type { Router } from 'vue-router'
import { canAccessRoute } from '@/router/access'

export default function verifyPermissionGuard(router: Router) {
  router.beforeEach((to, _from, next) => {
    // 异常页 / 内部工具页不参与业务权限控制，避免死循环或误拦截。
    if (to.name === 'Forbidden' || to.name === 'NotFound' || to.name === 'SvgView') {
      next()
      return
    }

    const requiresAuth = to.matched.some(route => route.meta?.requiresAuth)
    if (!requiresAuth) {
      next()
      return
    }

    // 登录态已由前一个守卫保证，这里只负责“当前用户是否允许进入该业务路由”。
    if (!canAccessRoute(to)) {
      next({
        name: 'Forbidden',
        query: {
          // 保留原始目标地址，便于后续提示页返回或排查命中的权限规则。
          redirect: to.fullPath,
        },
        replace: true,
      })
      return
    }

    next()
  })
}
